export class cBrowserVersion {
  parent = document.querySelector('body') as HTMLElement;
  div    = document.createElement('div');
  p      = document.createElement('p');
  button = document.createElement('button');

  constructor() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.parent.append(this.div);
      this.div.append(this.p);
      this.div.append(this.button);
    
    this.div.style.bottom              = '0';
    this.div.style.right               = '0';
    this.div.style.left                = '0';
    this.div.style.position            = 'fixed';
    this.div.style.zIndex              = '5000';
    this.div.style.padding             = '20px'
    this.div.style.display             = 'grid';
    this.div.style.gridTemplateColumns = '1fr auto';
    this.div.style.alignItems          = 'center';
    this.div.style.justifyItems        = 'center';
    this.div.style.backgroundColor     = 'red';

    this.p.style.color                 = 'white';
    this.p.style.fontWeight            = '600';
    this.p.style.fontSize              = '18px';
    this.p.style.margin                = '0';

    this.button.innerText = 'X';
    this.button.type      = 'button';

    this.p.innerText = __('Ihr Browser wird nicht mehr unterstützt.', 'custom');

    this.button.addEventListener('click', () => this.div.style.display = 'none');
  }

  static browserSuppored() {
    if ('checkVisibility' in Element.prototype) return true;
    else return false;
  }

}